import config from '@/config/index';

/**
 * 增加项目
 *
 * @param title            标题
 * @param projectdetail    详情
 * @param projectdeeplearn 项目解读
 * @param initiatoruid     发起人uid
 * @param phase            项目阶段 1.看政策2.查项目3.找资金4.获担保
 * @param industrycategory 行业分类
 * @param amountlower      资金下限
 * @param amountupper      资金上限
 * @param nonamount        资金面议 1 生效
 * @param expiredtime      项目截止日期
 * @param contacts         联系人
 * @param mobile           电话
 * @param province         省份
 * @param district         地区
 * @param projecttype      分类：0 产品 1 服务
 * @param projectcategory  服务分类 或者 产品分类
 * @param imgs             项目图片
 * @param isshow           是否显示 0 不显示 1 显示
 * @param request
 * @return
 * @PostMapping("/project")
 */
function addProject() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/project`;
}

/**
 * 修改项目(用户端)
 *
 * @param pid              项目id
 * @param title            标题
 * @param projectdetail    详情
 * @param projectdeeplearn 项目解读
 * @param initiatoruid     发起人uid
 * @param phase            项目阶段 1.看政策2.查项目3.找资金4.获担保
 * @param industrycategory 行业分类
 * @param amountlower      资金下限
 * @param amountupper      资金上限
 * @param nonamount        资金面议 1 生效
 * @param expiredtime      项目截止日期
 * @param contacts         联系人
 * @param mobile           电话
 * @param province         省份
 * @param district         地区
 * @param isshow           是否显示 0 不显示 1 显示
 * @param projecttype      分类：0 产品 1 服务
 * @param projectcategory  服务分类 或者 产品分类
 * @param imgs             项目图片
 * @param request
 * @return
 * @PostMapping("/modifyproject")
 */
function modifyProject() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/modifyproject`;
}

/**
 * ES搜索 -  项目搜索
 * @param projecttype
 * @param industrycategory
 *  @param projectcategory
 * @param page           当前第几页
 * @param limit          限制多少页
 * @param request
 * @return
 * @GetMapping("/searchproject")
 */
function searchproject() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/searchproject`;
}

/**
 * 获取项目详情
 *
 * @param pid
 * @param request
 * @return
 * @GetMapping("/project/{pid}")
 */
function getProject(pid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/project/${pid}`;
}

/**
 * 用户项目报名
 *
 * @param pid      账号id
 * @param uid      用户id
 * @param contacts 联系人
 * @param mobile   手机号
 * @param content  留言内容
 * @return
 * @PostMapping("/projectsingup")
 */
function projectSingup() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/projectsingup`;
}

/**
 * 获取项目列表（发起人看到自己发起过的项目列表）
 * 读取header 的uid来识别用户
 *
 * @param request
 * @return
 */
function getMyProjects() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/myprojects`;
}

/**
 * 获取项目报名列表(前端用)
 * 只返回通过审核的报名
 *
 * @param pid     项目id
 * @param request
 * @return
 * @GetMapping("/projectsingups")
 */
function projectSingups() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/projectsingups`;
}

/**
 * @param pid     项目id
 *                读取header 的uid来识别用户
 *                该接口只能由项目创建者本人来删除。
 * @param request
 * @return
 * @PostMapping("/deletemyproject")
 */
function deleteMyProject() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/deleteMyProject`;
}

/**
 * 获取我参加报名的项目列表（
 * 读取header 的uid来识别用户
 *
 * @param request
 * @return
 *  @GetMapping("/myprojectsignupelist")
 */
function myprojectsignupelist() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/myprojectsignupelist`;
}

/**
 * 项目评价 （ 项目发起人对 项目发起、修改评价）
 *
 * @param pid     账号id
 * @param stars   几颗星
 * @param comment 评价内容
 * @return
 * @PostMapping("/projectcomment")
 */
function projectcomment() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/projectcomment`;
}

export {
  addProject,
  modifyProject,
  searchproject,
  getProject,
  projectSingup,
  projectSingups,
  deleteMyProject,
  myprojectsignupelist,
  projectcomment,
  getMyProjects
}
